export const cardWidth = 390;
export const cardHeight = 450;
export const tableWidth = 350;
export const mainIconWidth = 42;
export const mainGradientDotWidth = 70;
export const gridWidth = 800;
export const rowHeight = 40;
export const tooltipShim = 7;

export const DETECTIONS_BY_PRODUCTION_COMPANY_WRAPPER_ID =
    'detections-by-production-company-wrapper';
export const TOP_PUBLISHERS_WRAPPER_ID = 'publishers-summary-wrapper';
